<!-- 大图 +自定义内容 -->
<template>
	<div>

		<div class="cc w-100" style="position:absolute;  z-index: 90;  " :style="titlestyle1">



			<div class="basetext" style="color: white;text-align: center;">
				<div class="basetext1" style="font-family: YouSheBiaoTiHei;"> 数据驱动</div>
				<div class="basetext1 subtextmarg"  style=" font-family: YouSheBiaoTiHei; 
						 
						-webkit-text-fill-color:transparent; 
						 -webkit-text-stroke:1px white; "> 星链全球</div>
				<div class="basetext2" > 为行业注入智能，用数据提升效能</div>
			</div>

		</div>
		<img class="firstimage" :src="imgobj" @load="onimagesize2">

		</img>

	</div>
</template>

<script>
	export default {
		name: 'firstsceenbase',
		props: ['imgobj'],
		data() {
			return {
				titlestyle1: {
					color: 'black',
					height:"0px"
				},
			}
		},
		methods: {
			onimagesize2: function(e) {
				var height = e.path[0].clientHeight
				this.titlestyle1.height = (height-70)+"px"
			}


		},

		mounted() {


		}

	}
</script>


<style>
	.firstimage {
		/* position: absolute; */
		width: 100%;
		margin-bottom: auto;
		/* height: auto; */
		/* width: auto;   */
		/*加滤镜*/
		/* filter: blur(1px); //背景模糊设置 */
		/*-webkit-filter: grayscale(100%);*/
		/*filter:grayscale(100%); //背景灰度设置*/
		z-index: -11;
		object-fit: fill;
	}

	@media (min-width: 1px) {
		.basetext {
			margin-top: 30px;
		}

		.basetext1 {
			font-size: 30px;
			letter-spacing: 10px;

		}
		.subtextmarg{
			margin-top: 0px;
		}
		.basetext2{
			 font-size: 10px;
			  letter-spacing: 6px;
		}
	}

	@media (min-width: 1000px) {
		.basetext {
			margin-top: 200px;
		}
		.subtextmarg{
			margin-top: -30px;
		}

		.basetext1 {
			font-size: 100px;
			letter-spacing: 65px;
		}
		.basetext2{
			 font-size: 17px;
			  letter-spacing: 12px;
		}
	}
</style>
